import React from 'react';
import { flexRender, HeaderGroup } from '@tanstack/react-table';
import { StyledInnerTh, StyledTh, StyledThead } from './styles';
import { getCommonPinningStyles } from '../utils/getCommonPinningStyles';
import TanstackTableFilter from '../TanstackTableFilter';

type TableHeaderProps<TData> = {
  headerGroups: HeaderGroup<TData>[];
};

const TableHeader = <TData,>({ headerGroups }: TableHeaderProps<TData>): JSX.Element => {
  const hasFilter = headerGroups.some((headerGroup) =>
    headerGroup.headers.some((header) => header.column.getCanFilter()),
  );

  return (
    <StyledThead>
      {headerGroups.map((headerGroup) => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header) => {
            return (
              <StyledTh key={header.id} {...getCommonPinningStyles(header.column)} height={36}>
                <StyledInnerTh
                  onClick={header.column.getCanSort() ? header.column.getToggleSortingHandler() : undefined}
                  cursor={header.column.getCanSort() ? 'pointer' : 'default'}
                >
                  {header.column.getCanSort() &&
                    (header.column.getIsSorted()
                      ? {
                          desc: `▼ `,
                          asc: `▲ `,
                        }[String(header.column.getIsSorted())]
                      : `▬ `)}
                  {flexRender(header.column.columnDef.header, header.getContext())}
                </StyledInnerTh>
              </StyledTh>
            );
          })}
        </tr>
      ))}
      {hasFilter && (
        <tr>
          {headerGroups.map((headerGroup) =>
            headerGroup.headers.map((header) => {
              const Filter = header.column.columnDef.meta?.Filter;

              return (
                <StyledTh key={`filter-${header.id}`} {...getCommonPinningStyles(header.column)} height={56}>
                  <StyledInnerTh>
                    {header.column.getCanFilter() ? (
                      Filter ? (
                        <Filter column={header.column} />
                      ) : (
                        <TanstackTableFilter column={header.column} />
                      )
                    ) : null}
                  </StyledInnerTh>
                </StyledTh>
              );
            }),
          )}
        </tr>
      )}
    </StyledThead>
  );
};

export default TableHeader;
